/* global jQuery */

const FloatLabel = (() => {
  // add active class and placeholder
  const handleFocus = (e) => {
    const target = e.target;
    if (target) {
      target.closest('div.gfield').classList.add('is-active');
    }
  };

  // remove active class and placeholder
  const handleBlur = (e) => {
    const target = e.target;
    if (!target.value) {
      target.closest('div.gfield').classList.remove('is-active');
    }
  };

  // register events
  const bindEvents = (element) => {
    const floatField = element.querySelector('input:not([type=checkbox]):not([type=file]):not([type=radio]), textarea');
    if (floatField) {
      floatField.addEventListener('focus', handleFocus);
      floatField.addEventListener('blur', handleBlur);
    }
  };

  // get DOM elements
  const init = () => {
    const floatContainers = document.querySelectorAll('.gfield');
    floatContainers.forEach((element) => {
      let inputEl = element.querySelector('input:not([type=checkbox]):not([type=file]):not([type=radio]), textarea');
      if (inputEl && inputEl.value) {
        element.classList.add('is-active');
      }
      bindEvents(element);
    });
  };

  return {
    init: init,
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  FloatLabel.init();
});

//we cannot catch jquery events without jquery
jQuery(document).on('gform_post_render', function () {
  FloatLabel.init();
});
